import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { TextField } from "@mui/material";

interface OcTextInputFieldProps {
  label: string;
  value: string;
  setValue: (value: string) => void;
  error: boolean;
  setError: (error: boolean) => void;
  helperText: string;
  setHelperText: (text: string) => void;
  optional?: boolean;
  defaultValue?: string;
}

export const OcTextInputField: React.FC<OcTextInputFieldProps> = ({
  label,
  value,
  setValue,
  error,
  setError,
  helperText,
  setHelperText,
  optional,
  defaultValue,
}) => {
  const { t } = useTranslation();

  useEffect(() => {
    return () => {
      setValue("");
      setError(false);
      setHelperText("");
    };
    // eslint-disable-next-line
  }, []);

  return (
    <TextField
      label={label}
      variant="outlined"
      fullWidth
      value={value}
      defaultValue={defaultValue}
      onChange={(e) => setValue(e.target.value)}
      error={error}
      helperText={optional ? t("OC_OPTIONAL") : helperText}
      onFocus={() => {
        setError(false);
        setHelperText("");
      }}
    />
  );
};

export default OcTextInputField;
